<mat-accordion [multi]="false">
    @for (sceneEffect of sceneEffects; track sceneEffect) {
        <mat-expansion-panel #effectPanel portalHandler 
            [disabled]="!existedEffects[sceneEffect.name]" 
            (opened)="panelOpened(sceneEffect.name, true)" 
            (closed)="panelOpened(sceneEffect.name, false)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-checkbox 
                        class="effect-check"
                        [checked]="existedEffects[sceneEffect.name]"
                        (change)="toggleEffect($event.checked, sceneEffect.name, effectPanel)">
                    </mat-checkbox>
                    <!-- <fa-icon class="effect-icon" size="lg" [icon]="sceneEffect.icon"></fa-icon> -->
                    <span class="effect-label">{{ sceneEffect.translator | transloco }}</span>
                    
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <app-block-effect-props [effectName]="sceneEffect.name">
                </app-block-effect-props>
            </ng-template>
        </mat-expansion-panel>
    }    
</mat-accordion>

